import { getToken } from '@/utils/auth'
import coordtransform from 'coordtransform'
import * as xlsx from 'xlsx'

// export function timeFix () {
//   const time = new Date()
//   const hour = time.getHours()
//   return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
// }

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function millsToTime (mills) {
  if (!mills) {
    return ''
  }
  const s = mills / 1000
  if (s < 60) {
    return s.toFixed(0) + ' 秒'
  }
  const m = s / 60
  if (m < 60) {
    return m.toFixed(0) + ' 分钟'
  }
  const h = m / 60
  if (h < 24) {
    return h.toFixed(0) + ' 小时'
  }
  const d = h / 24
  if (d < 30) {
    return d.toFixed(0) + ' 天'
  }
  const month = d / 30
  if (month < 12) {
    return month.toFixed(0) + ' 个月'
  }
  const year = month / 12
  return year.toFixed(0) + ' 年'
};

/**
 * 格式化时间
 * @param fmt
 * @param date
 * @returns {*}
 */
export function dateFtt (fmt, date) {
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
/**
 * 面积转字符串
 * @param {Number} num 面积
 * @returns 面积字符串
 */
export function areaToString (num) {
  let label = String(num)
  label = label.substr(0, label.indexOf('.', 0))
  let text
  if (label.length < 6) { text = label + '㎡' } else {
    label = String(label / 1000000)
    label = label.substr(0, label.indexOf('.', 0) + 3)
    text = label + 'k㎡'
  }
  return text
}
/**
 * 距离转字符串
 * @param {Number} num 距离
 * @returns 距离字符串
 */
export function distanceToString (num) {
  let distacne = num
  if (distacne < 1000) {
    return distacne.toFixed(2) + 'm'
  } else {
    distacne = distacne / 1000
    return distacne.toFixed(2) + 'km'
  }
}

export function createColorRamp (config) {
  // 排列方向，0水平，1垂直
  const direction = config.direction ? 1 : 0
  const ramp = document.createElement('canvas')
  ramp.width = config.width
  ramp.height = config.height
  const ctx = ramp.getContext('2d')
  let grd = ctx.createLinearGradient(0, 0, ramp.width, 0)
  if (direction === 1) {
    grd = ctx.createLinearGradient(0, 0, 0, ramp.height)
  }
  // config.data.sort((a, b) => {
  //   return a.value - b.value
  // })
  for (let i = 0; i < config.data.length; i++) {
    const color = config.data[i].color
    const value = config.data[i].value
    grd.addColorStop(value, color)
  }
  ctx.fillStyle = grd
  ctx.fillRect(0, 0, config.width, config.height)
  return ramp.toDataURL('image/png')
}

// Object 深度克隆
export function cloneObject (originObj, destObject) {
  const keys = Object.keys(originObj)
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if ((typeof originObj[key]) === 'object') {
      cloneObject(originObj[key], destObject[key])
    } else {
      destObject[key] = originObj[key]
    }
  }
}

// 是否有坐标信息
export function isHaveGis (header) {
  let isHaveLon = false
  let isHaveLat = false
  for (let i = 0; i < header.length; i++) {
    if (header[i].tag && header[i].tag.indexOf('LONGITUDE') >= 0) {
      isHaveLon = true
    }
    if (header[i].tag && header[i].tag.indexOf('LATITUDE') >= 0) {
      isHaveLat = true
    }
  }
  return isHaveLon && isHaveLat
}

// 将base64转换为blob
export function dataURLtoBlob (dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  // var bstr = atob(arr[1])
  // var n = bstr.length
  // var u8arr = new Uint8Array(n)
  // while (n--) {
  //   u8arr[n] = bstr.charCodeAt(n)
  // }
  const u8arr = Buffer.from(arr[1], 'base64')
  return new Blob([u8arr], { type: mime })
}
// 将blob转换为file
export function blobToFile (theBlob, fileName) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

export function dataToFile (data, fileName) {
  return blobToFile(dataURLtoBlob(data), fileName)
}

// 文件下载
export async function downloadFile (url, name) {
  const token = getToken()
  const response = await fetch(url, {
    headers: {
      'Authorization': token
    }
  })
  if (response.ok === false) {
    throw new Error(response.statusText)
  }

  // 内容转变成blob地址
  const blob = await response.blob()
  // 创建隐藏的可下载链接
  const objectUrl = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  // 地址
  a.href = objectUrl
  // 修改文件名
  a.download = name
  // 触发点击
  document.body.appendChild(a)
  a.click()
  // 移除
  setTimeout(() => document.body.removeChild(a), 1000)
}

export function rafThrottle (fn) {
  let locked = false
  return function (...args) {
    if (locked) return
    locked = true
    window.requestAnimationFrame(_ => {
      fn.apply(this, args)
      locked = false
    })
  }
}
// dataset数据转table数据
export function dataset2table (data) {
  // console.log('origin data =', data)
  const keys = Object.keys(data)
  const tableDatas = []
  keys.forEach(key => {
    if (Array.isArray(data[key])) {
      for (let i = 0; i < data[key].length; i++) {
        if (!tableDatas[i]) {
          const item = {}
          item[key] = data[key][i]
          tableDatas.push(item)
        } else {
          tableDatas[i][key] = data[key][i]
        }
      }
    } else {
      if (!tableDatas[0]) {
        const item = {}
        item[key] = JSON.stringify(data[key])
        tableDatas.push(item)
      } else {
        tableDatas[0][key] = JSON.stringify(data[key])
      }
    }
  })
  // console.log('table data =', tableDatas)
  return tableDatas
}

export function coordTransform (coordinatesType, position) {
  const originLon = position[0] && !isNaN(parseFloat(position[0])) ? parseFloat(position[0]) : 0
  const originLat = position[1] && !isNaN(parseFloat(position[1])) ? parseFloat(position[1]) : 0
  let markerLon = originLon
  let markerLat = originLat
  let markerHeight = position[2] && !isNaN(parseFloat(position[2])) ? parseFloat(position[2]) : 0
  markerHeight = markerHeight.toFixed(2)
  if (originLon && originLat && coordinatesType === 'GAODE') {
    const location = coordtransform.gcj02towgs84(originLon, originLat)
    markerLon = location[0].toFixed(6)
    markerLat = location[1].toFixed(6)
  } else if (originLon && originLat && coordinatesType === 'BAIDU') {
    let location = coordtransform.bd09togcj02(originLon, originLat)
    location = coordtransform.gcj02towgs84(location[0], location[1])
    markerLon = location[0].toFixed(6)
    markerLat = location[1].toFixed(6)
  } else if (originLon && originLat && coordinatesType === 'WSG84') {
    markerLon = markerLon.toFixed(6)
    markerLat = markerLat.toFixed(6)
  }
  return [markerLon, markerLat, markerHeight]
}

export function isMobile () {
  return !!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
}

// json转换为Excel并下载
export function jsonToExcel (jsonData, fileName = 'default') {
  function s2ab (s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF
    }
    return buf
  }

  const wb = xlsx.utils.book_new()
  const ws = xlsx.utils.json_to_sheet(jsonData)
  wb.SheetNames.push(fileName)
  wb.Sheets[fileName] = ws
  const wbout = xlsx.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  })
  const blob = new Blob([s2ab(wbout)], {
    type: 'application/octet-stream'
  })
  const dlLink = document.createElement('a')
  dlLink.download = fileName + '.xlsx'
  dlLink.href = window.URL.createObjectURL(blob)
  dlLink.dataset.downloadurl = ['application/octet-stream', dlLink.download, dlLink.href].join(':')
  document.body.appendChild(dlLink)
  dlLink.click()
  document.body.removeChild(dlLink)
}

// 摄像机属性校验
export function validateCameraInfo (cameraInfo) {
  if (cameraInfo) {
    return cameraInfo.cameraLon && cameraInfo.cameraLat && cameraInfo.cameraHeight &&
      cameraInfo.cameraHeading && cameraInfo.cameraPitch
  }
  return false
}
